import moment from "moment";

import partyActions from "../Votify/VotifyParty/partyActions";
import socketActions from "./socketActions";

const SOCKET_TIMEOUT_THRESHOLD_MS = 30000;

export const handleSocketAck = () => {
  return {
    type: partyActions.SOCKET_ACK_PARTY,
  };
};

export const handleSocketNotAck = () => {
  return {
    type: partyActions.SOCKET_NOT_ACK_PARTY,
  };
};

export const handleConnection = () => {
  return { type: socketActions.SOCKET_GOT_CONNECTION };
};
export const handleMessage = () => {
  return { type: socketActions.TOUCH, payload: { lastUpdated: moment() } };
};

export const handleLostConnection = (timeoutMs) => {
  return (dispatch, getState) => {
    const currentTimeout = getState().socket.timeoutMs + timeoutMs;
    dispatch({
      type: socketActions.SOCKET_TIMEOUT,
      payload: { timeoutMs },
    });

    if (currentTimeout > SOCKET_TIMEOUT_THRESHOLD_MS) {
      dispatch({
        type: socketActions.SOCKET_LOST_CONNECTION,
      });
    }
  };
};
